import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import Select from 'react-select'
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';

const ModalCreateEncuesta =({buscar_cis,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    useEffect(()=>{
      if(editActive){
        buscar_encuesta()
      }
    },[])
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({
        // name_brand:(editActive)?groupSelected.name_brand:"",
            code: (editActive)?groupSelected.code:"",
            title: (editActive)?groupSelected.title:"",
            description:(editActive)?groupSelected.description:"",
            trigger_id: (editActive)?((groupSelected.trigger_id==""||groupSelected.trigger_id==null)?null:groupSelected.trigger_id):null,
            period_id: (editActive)?((groupSelected.period_id==""||groupSelected.period_id==null)?null:groupSelected.period_id):null,
          
        })

    const [OptionsData,setOptionsData]=useState([{
            question_text: "",
            type: "text",
            options: []
            }])
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const dataTriggers=useFetch('cassia/surveys/survey_triggers','','','GET',server)
    const dataPeriods=useFetch('cassia/surveys/survey_periods','','','GET',server)


    const levels=[
        {
            id:1,
            name:"Texto",
            cassia_criticality_id:1
        },
        {
            id:2,
            name:"Multiple",
            cassia_criticality_id:2
        },
        
    ]
    const options = [
        { value: 1, label: 'Texto',type:'text' },
        { value: 2, label: 'Multiple', type:'multiple'}, // Deshabilitada
      ];
    let defaultOption;
    if(editActive){
       defaultOption = OptionsData.map(bItem => {
        // Encontrar el objeto en A que coincida con el tipo de B
        const matchingA = options.find(aItem => aItem.type === bItem.type);
        // Si se encuentra, se devuelve el objeto correspondiente de A
        return matchingA ? { ...matchingA } : null;
      }).filter(item => item !== null); // Filtramos los elementos nulos en caso de no encontrar coincidencias
      
    }else{ defaultOption = { value: 1, label: 'Texto' ,type:'text' };}

    const handleChange=(e)=>{
        // console.log(e.target.name)
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }
            
          
       
        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                
            }
           
           
          }

        
        
      }

    useEffect(()=>{
     
          if( ManttoData.name_brand=="" || ManttoData.mac_address_brand_OUI=="" ){
              // console.log('disabled')
              setDisabled(true)
          }else{
              // console.log('no disabled')
              setDisabled(false)
          }
    },[ManttoData])
    const [loadingEncuesta,setLoadingEncuesta]=useState(false)
    const [dataTest,setDataTest]=useState([])
    const buscar_encuesta = () => {
      setLoadingEncuesta(true)
      const fetchDataPost = async () => {
        try {
          
          const response = await fetch(
            server.url +
              "/api/v1/cassia/surveys/_surveys/"+groupSelected.id+"/questions/",
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              },
            }
          );
          // console.log(response);
          if (response.ok) {
              const data1 = await response.json();
              setLoadingEncuesta(false)
              setOptionsData(data1.message)
          } else {
              const data1 = await response.json();
              throw new Error("Error en la solicitud");
          }
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchDataPost();
    };
    const RegistrarEncuesta=()=>{
      
      let method='POST'
      let url_add=''
      if(editActive){
          method='PUT'
          url_add=groupSelected.id
      }
     
      let  body ={}
      
     
     
      // console.log(body)
      setLoading(true)
        const fetchDataPost = async () => {
          
       try {
         
            const response = await fetch(server.url+'/api/v1/cassia/surveys/_surveys/'+url_add, {
              method: method,  
              headers: {
                 "Accept": "application/json",
                // 'Content-Type': 'application/json',
                'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
              body: JSON.stringify(ManttoData),
            });
          //  console.log(response)
            if (response.ok) {
                const data1 = await response.json();
                RegistrarPreguntas(data1.data.id)
                setData(data1)

                // handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
                // console.log(data1);
                // closCreateCisModal()
                // setRegisterIsValid(true)
            } else {
              const data1 = await response.json();
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
              setHostName("")
              
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };
    
        fetchDataPost();
        
  }
    const RegistrarPreguntas=(id)=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.brand_id
        }

        // OptionsData.forEach(question => {
        //   question.survey_id = id;
        // });


        const data={
         "survey_id": (editActive)?groupSelected.id:id,
         "questions":OptionsData
        }
        // setLoading(true)
        const fetchDataPost = async () => {
          
       try {
         
            const response = await fetch(server.url+'/api/v1/cassia/surveys/_questions/', {
              method: method,  
              headers: {
                 "Accept": "application/json",
                // 'Content-Type': 'application/json',
                'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
              body: JSON.stringify(data),
            });
          //  console.log(response)
            if (response.ok) {
                const data1 = await response.json();
                setLoading(false)
                setData(data1)

                handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
                // console.log(data1);
                buscar_cis()
                closCreateCisModal()
                setRegisterIsValid(true)

                const timer = setTimeout(() => {
                  setRegisterIsValid(false)
                  setEditActive(false)
                  closCreateCisModal()
                }, 3000);
            } else {
              const data1 = await response.json();
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
              setHostName("")
              
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }


    const [typeQuestion,setTypeQuestion]=useState(1)
    // console.log("tipo pregunta",typeQuestion)
    const changeTypeQuestion=(selected,element,index)=>{
        const updatedData = [...OptionsData];
        // Modificar el objeto en la posición indicada
        updatedData[index] = { ...updatedData[index], type: selected.type};
        // Actualizar el estado
        setOptionsData(updatedData);
        // setOptionsData((prevState)=>{
        //     return {
        //         ...prevState,
        //         ['trigger_id']:option.value===0?null:(parseInt(option.value))
        //     }

        // })


        // setManttoRelation(option.value)
    }
    const changeOption=(option,index)=>{
        
        // console.log(option)
       
        if(option.filter=="trigger"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['trigger_id']:option.value===0?null:(parseInt(option.value))
                }
                
            })
        }else if(option.filter=="period"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['period_id']:option.value===0?null:(parseInt(option.value))
                }
                
            })
        }else if(option.filter=="Estados"){
            setTypeQuestion(parseInt(option.value))
        }
        
        // setManttoRelation(option.value)
            
    }

    const [fecha, setDate] = useState('2023-09-28')

    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const addQuestion=()=>{
        const newOption = { // Genera un ID secuencial
            question_text: "",
            type: "text",
            options: []
          };
      
          // Agrega el nuevo objeto al final del arreglo
          setOptionsData(prevOptions => [...prevOptions, newOption]);
    }
    const addOptionToItem = (index) => {
        setOptionsData(prevOptions => {
          // Hacer una copia del arreglo actual
          const updatedOptions = [...prevOptions];
          
          // Agregar el nuevo valor a la propiedad options del objeto en la posición especificada
          updatedOptions[index] = {
            ...updatedOptions[index],
            options: [...updatedOptions[index].options, ""]
          };
          
          return updatedOptions;
        });
      };
    const removeOptionFromItem = (itemIndex, optionIndex) => {
      setOptionsData(prevOptions => {
        // Crear una copia del arreglo actual
        const updatedOptions = [...prevOptions];
  
        // Crear una copia del array options del objeto y eliminar la opción deseada
        const updatedItemOptions = [...updatedOptions[itemIndex].options];
        updatedItemOptions.splice(optionIndex, 1); // Eliminar la opción en la posición especificada
  
        // Actualizar el objeto con el nuevo array de opciones
        updatedOptions[itemIndex] = {
          ...updatedOptions[itemIndex],
          options: updatedItemOptions
        };
  
        return updatedOptions;
      });
    };
    const removeItem = (index) => {
      setOptionsData(prevOptions => {
        // Crear una copia del arreglo y eliminar el elemento en la posición especificada
        const updatedOptions = [...prevOptions];
        updatedOptions.splice(index, 1); // Eliminar el objeto en la posición `index`
  
        return updatedOptions;
      });
    };
    const handleChangeOptions = (e, index, optionIndex) => {
      const { value } = e.target;
  
      setOptionsData(prevOptions => {
        // Hacer una copia del arreglo actual
        const updatedOptions = [...prevOptions];
  
        // Crear una copia del objeto en el índice especificado
        const updatedItem = { ...updatedOptions[index] };
  
        // Crear una copia del array de opciones y actualizar la opción específica
        updatedItem.options = [...updatedItem.options];
        updatedItem.options[optionIndex] = value;
  
        // Reemplazar el objeto modificado en el arreglo principal
        updatedOptions[index] = updatedItem;
  
        return updatedOptions;
      });
    };
    const handleQuestionTextChange = (e, index) => {
      const { value } = e.target;
  
      setOptionsData(prevOptions => {
        // Crear una copia del arreglo actual
        const updatedOptions = [...prevOptions];
        
        // Modificar el campo question_text del objeto en la posición especificada
        updatedOptions[index] = {
          ...updatedOptions[index],
          question_text: value
        };
        
        return updatedOptions;
      });
    };
    const {code,title,description,trigger_id,period_id}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {(editActive)?capitalizeFirstLetter(lang[languaje]['editar']):capitalizeFirstLetter(lang[languaje]['crear'])  }
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',height:'95%'}}>
                
                                    <div className="form-GS-box" style={{height: '95%'}}> 
                                    
                                    
                                    
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="title"  type="text" value={title}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['titulo'])}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="code"  type="text" value={code}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['codigo'])}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        
                                    </div>
                                    <div className="user-box-GS "  style={{height:'13%'}}>
                                        {
                                            (dataTriggers.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(dataTriggers==null)?0:trigger_id} origen={'Admin'} data={dataTriggers.data.data}   loading={dataTriggers.loading}  titulo='trigger' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['disparador'])}</label>   
                                    </div>
                                    <div className="user-box-GS "  style={{height:'13%'}}>
                                        {
                                            (dataPeriods.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(dataPeriods==null)?0:period_id} origen={'Admin'} data={dataPeriods.data.data}   loading={dataPeriods.loading}  titulo='period' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['periodo'])}</label>   
                                    </div>
                                    <div className="user-box-GS "  style={{height:'5%'}}>
                                        <div className='addQuestion'>
                                            <img class="img-field-add-graf" style={{height: '100%'}} src="/iconos/add.png" title="Agregar" name="Agregar" onClick={addQuestion}/>
                                        </div>
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['preguntas'])}</label>   
                                    </div>
                                    <div className='content-questions-gs'>
                                        {/*  */}
                                        {(loadingEncuesta)?<LoadSimple></LoadSimple>:
                                          <>
                                            {
                                            OptionsData.map((element,index)=>(
                                                <div className='cont-row-question-gs'>
                                            <div className='compact-row-question-gs'>
                                                <div className='title-row-question-gs'>
                                                        {capitalizeFirstLetter(lang[languaje]['pregunta'])+" "+(index+1)}
                                                        {
                                                            (index!=0)?<div className='deleteQuestion' onClick={()=>removeItem(index)}>
                                                            X
                                                        </div>:''
                                                        }
                                                </div>
                                                <div className='body-row-question-gs'>
                                                <div className="form-GS-box" style={{height:'auto',minHeight: '100px'}}> 
                                    
                                    
                                                <div className="user-box-GS"  style={{height:'20px'}}>
                                    
                                    </div>
                                    <div className="user-box-GS"  style={{height:'50px'}}>
                                    <input required name="question_text"  type="text" value={element.question_text}
                                    onChange={(e)=>handleQuestionTextChange(e,index)}  />
                                        <label className='label-GS  ' style={{top:'-15px'}}>{capitalizeFirstLetter(lang[languaje]['pregunta'])}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'30px'}}>
                                    {/* {
                                           
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={1} origen={'Admin'} data={levels}   loading={false}  titulo='Estados' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        } */}
                                        <div className='menuSearchOptionGS' style={{padding:'unset'}}>
                                        <div className={'compactSelectorAdminGS'}>
                                                <Select 
                                                    className="react-select-container-admin-gs"
                                                    classNamePrefix="react-select-admin-gs"
                                                    options={options} 
                                                    defaultValue={(editActive?defaultOption[index]:defaultOption)}
                                                    onChange={(selected)=>changeTypeQuestion(selected,element,index)}
                                                />
                                        </div>
                                        </div>
                                        <label className='label-GS  ' style={{top:'-10px'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>
                                        
                                    </div>
                                    {
                                        (element.type=="multiple")?
                                        <div className="user-box-GS "  style={{height:'50px',top:'15px'}}>
                                        <div className='addQuestion'>
                                            <img class="img-field-add-graf" style={{height: '20px'}} src="/iconos/add.png" title="Agregar" name="Agregar" onClick={()=>addOptionToItem(index)}/>
                                        </div>
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['opciones'])}</label>   
                                    </div>:''
                                    }
                                    {
                                        (element.type=="multiple")?
                                        <>
                                        {
                                            element.options.map((textOption,optionIndex)=>(
                                                <div className="user-box-GS"  style={{height:'50px'}}>
                                        <input required name="title"  type="text" value={textOption}
                                        onChange={(e) => handleChangeOptions(e, index, optionIndex)}  />
                                            <label className='label-GS  ' style={{top:'-15px'}}>{capitalizeFirstLetter(lang[languaje]['opcion'])+" "+(optionIndex+1)}</label>
                                            {
                                            <div className='deleteOptionQuestion' onClick={()=>removeOptionFromItem(index,optionIndex)}>
                                                X
                                            </div>
                                            }
                                        </div>
                                            ))
                                        }
                                        
                                        </>
                                        :''
                                    }
                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                            ))
                                        }
                                          </>
                                        }
                                        {/*  */}
                                    </div>
                                    
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'33%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={RegistrarEncuesta}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateEncuesta